// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b7d653ba","239":"3616f0be","282":"3d8c6e9e","453":"2943f026","622":"e7a5a688","667":"126125c5","879":"7520ac6b"}[chunkId] + ".chunk.js";
};